export default __webpack_public_path__ + "static/media/paper-docs.cd93b9a6.svg";